import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSubmitted: null,
    selectedPincode: null,
    dealerName: ""
};

export const updateSelectedPincode = (state = INITIAL_STATE, { selectedPincode }) => {
    return { ...state, selectedPincode };
};

export const updateIsSubmitted = (state = INITIAL_STATE, { isSubmitted }) => {
    return { ...state, isSubmitted };
};

export const updateDealerName = (state = INITIAL_STATE, { dealerName }) => {
    return { ...state, dealerName };
};

export const HANDLERS = {
    [Types.UPDATE_PINCODE_SELECTION]: updateSelectedPincode,
    [Types.UPDATE_IS_SUBMITTED]: updateIsSubmitted,
    [Types.UPDATE_DEALER_NAME]: updateDealerName
};

export default createReducer(INITIAL_STATE, HANDLERS);
